// PROMO: 50% off main product via discount code + free bottle swap
// Code: JUBOTTLE

const PROMO_CODE = 'JUBOTTLE';

// Variant IDs
const PINK_PAID = 48467292324045;
const PINK_FREE = 48521081651405;
const ORANGE_PAID = 48467300778189;
const ORANGE_FREE = 48521076637901;

async function getCart() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  return res.json();
}

async function changeLine(lineKey, qty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: lineKey, quantity: qty })
  });
}

async function addItem(variantId) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
}

function promoActive(cart) {
  return cart.discount_codes?.some(
    d => (d.code || '').toUpperCase() === PROMO_CODE.toUpperCase()
  );
}

async function syncBottle() {
  try {
    const cart = await getCart();
    const promo = promoActive(cart);

    const paidPink = cart.items.find(i => i.variant_id === PINK_PAID);
    const paidOrange = cart.items.find(i => i.variant_id === ORANGE_PAID);

    const freePink = cart.items.find(i => i.variant_id === PINK_FREE);
    const freeOrange = cart.items.find(i => i.variant_id === ORANGE_FREE);

    // If code is active: swap paid bottle -> free bottle
    if (promo) {
      if (paidPink) {
        await changeLine(paidPink.key, 0);
        if (!freePink) await addItem(PINK_FREE);
        return;
      }

      if (paidOrange) {
        await changeLine(paidOrange.key, 0);
        if (!freeOrange) await addItem(ORANGE_FREE);
        return;
      }

      // If they already have free bottle, do nothing
      return;
    }

    // If code is NOT active: remove any free promo bottles
    if (freePink) {
      await changeLine(freePink.key, 0);
      return;
    }
    if (freeOrange) {
      await changeLine(freeOrange.key, 0);
      return;
    }
  } catch (e) {
    console.warn('[promo-bottle] error', e);
  }
}

// Make callable from your existing AJAX cart refresh code
window.syncPromoBottle = syncBottle;

// Run on initial load + a couple delayed retries (helps with AJAX carts)
document.addEventListener('DOMContentLoaded', () => {
  syncBottle();
  setTimeout(syncBottle, 800);
  setTimeout(syncBottle, 1800);
});

// If your theme dispatches these, great — if not, no harm
document.addEventListener('cart:updated', syncBottle);
document.addEventListener('cart:refresh', syncBottle);

